/**
 * Global Search - Urdu Translations
 */

export const globalSearchUr = {
  globalSearch: {
    title: 'تلاش',
    placeholder: 'آرڈرز، شپمنٹس، مقامات تلاش کریں...',
    shortcut: 'دبائیں',
    shortcutKey: 'K',
    noResults: 'کوئی نتائج نہیں ملے',
    noResultsDescription: 'اپنی تلاش کی شرائط کو ایڈجسٹ کرنے کی کوشش کریں',
    loading: 'تلاش کر رہے ہیں...',
    error: 'تلاش ناکام ہوگئی',
    minChars: 'کم از کم 2 حروف ٹائپ کریں',
    results: {
      orders: 'آرڈرز',
      salesOrders: 'سیلز آرڈرز',
      shipments: 'شپمنٹس',
      locations: 'مقامات',
      visitors: 'زائرین',
      visits: 'دورے',
      gates: 'دروازے',
      zones: 'زونز',
      drivers: 'ڈرائیورز',
      assets: 'اثاثے',
      tenants: 'کرایہ دار',
      invoices: 'انوائسز',
      products: 'مصنوعات',
    },
    viewAll: 'تمام نتائج دیکھیں',
    recent: 'حالیہ تلاشیں',
    clear: 'صاف کریں',
  },
}
